import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        addressContainer: {
            flexDirection: 'column',
            gap: remCalc(4),
        },
        formTitle: {
            textStyle: 'body-large',
            paddingBottom: remCalc(16),
            borderBottomColor: 'border.dark',
            borderBottomWidth: remCalc(1),
        },
        formContainer: {
            paddingBottom: remCalc(24),
        },
        clearFieldsContainer: {
            justifyContent: 'space-between',
            py: remCalc(16),
        },
        addressFieldsContainer: {
            pb: remCalc(32),
        },
        privacyNoteText: {
            textStyle: 'body-small',
            color: 'text.secondary',
            pb: remCalc(16),
        },
        accuracyNoteText: {
            textStyle: 'body-small',
            bgColor: 'background.light',
            borderColor: 'border.light',
            borderWidth: remCalc(1),
            borderStyle: 'solid',
            padding: remCalc(26),
            alignItems: 'center',
            marginBottom: remCalc(16),
            gap: remCalc(16),
        },
    },
    variants: {
        'account-address': {
            formTitle: {
                textStyle: {base: 'head-large', md: 'head-large', lg: 'head-xlarge'},
                paddingTop: {base: remCalc(16), lg: remCalc(24)},
                paddingBottom: remCalc(24),
                fontWeight: 'medium',
                borderBottom: 'small',
            },
            formContainer: {
                paddingTop: 0,
            },
        },
    },
}
